import { observable, computed } from "mobx";
import { CityModel } from "./city.model";
import { TransTokens } from "../i18n";
import { CountryEntity } from "@citychallenge/api-public";

interface CountryEntityData extends CountryEntity {
  cities: CityModel[];
}

export class CountryModel implements CountryEntityData {
  @observable
  public id!: string;

  @observable
  public name!: string;

  @observable
  public cities!: CityModel[];

  constructor(data: CountryEntityData) {
    Object.assign(this, data);
  }

  @computed
  public get translatedName() {
    return TransTokens.getTranslation(this.name).interpolate();
  }

  public contains(regex: RegExp) {
    const { translatedName } = this;

    return regex.test(translatedName);
  }
}
